<template>
    <GenericMultiStepModal :header-icon="IconSource.Food" :modal-class="currentStep.width" :is-final-step="isFinalStep" @closing="onModalClose">
        <template #default="scope">
            <slot v-bind="scope" />
        </template>
        <template #component="scope">
            <component
                :is="currentStep.component"
                v-model:value="form"
                :text="isFinalStep ? $t('views.feed.reconciliations.newModal.successMessage') : undefined"
                @submit="next"
                @close="scope.close"
            ></component>
        </template>
    </GenericMultiStepModal>
</template>

<script lang="ts">
import { defineComponent, Ref } from 'vue';
import { Form } from '@makeabledk/vue-ui/support/http';
import GenericMultiStepModal from '@/components/common/GenericMultiStepModal.vue';
import { store } from '@/plugins/store';
import { ActionType } from '@/plugins/store/actions';
import { IconSource } from '@/types';
import ReconciliationProperties from '@/views/dashboard/feed/feedReconciliations/newReconciliationModal/ReconciliationProperties.vue';
import ReconciliationNextStepPlaceholder from '@/views/dashboard/feed/feedReconciliations/newReconciliationModal/ReconciliationNextStepPlaceholder.vue';
import GenericSubmissionStatus from '@/components/common/GenericSubmissionStatus.vue';
import useMultiSteps from '@/components/common/composables/useMultiSteps';
import useResettableForm from '@/components/common/composables/useResettableForm';

export default defineComponent({
    components: { GenericMultiStepModal, GenericSubmissionStatus },
    setup() {
        store.dispatch(ActionType.GetMixes);
        store.dispatch(ActionType.GetFarms);
        store.dispatch(ActionType.GetBarns);
        store.dispatch(ActionType.GetBatches);

        const multiSteps = useMultiSteps([
            {
                component: ReconciliationProperties,
                width: 'w-128',
            },
            {
                component: ReconciliationNextStepPlaceholder,
                width: 'w-228',
            },
            {
                component: GenericSubmissionStatus,
                width: 'w-128',
            },
        ]);

        const resettableForm = useResettableForm().setInitial({
            location: null,
            fromStatusDate: '',
            toStatusDate: '',
        });
        const form = resettableForm.getInstance() as Ref<Form<any> & any>;

        function onModalClose() {
            multiSteps.reset();
            resettableForm.reset();
            return true;
        }

        return {
            onModalClose,
            ...multiSteps,
            form,
            IconSource,
        };
    },
});
</script>
